import React from 'react';
import styles from './AuthHeader.module.css';
import { NavLink } from 'react-router-dom';

const AuthHeader = ({ action }) => {
    return (
        <div className={styles.authHeader}>
            <NavLink to='/'>
                <img
                    className={styles.logo}
                    //src='./Authentication/dealygoIcon.png'
                    src='/Asset/logo.png'
                    alt='DealyGo'
                />
            </NavLink>
        
            <h1 className={styles.title}>
                {action} à DealyGo
            </h1>
        </div>
    );
};

export default AuthHeader;